import { Text } from '@nike/eds';
import { Footer } from '../shared/footer/Footer';

export function LoginError(props: any) {
  return (
    <div className="eds-flex eds-flex--direction-column eds-flex--align-items-center eds-flex--justify-content-center eds-spacing--mt-56 eds-gap--16">
        <Text font ="title-4" as="h4" className="eds-spacing--mt-24">Authentication error</Text>
        <Text>You are not assigned to the correct group in order to access this application.</Text>
        <Text font='body-2'><strong>Please, follow these instructions:</strong></Text>
        <div>
          <Text className='eds-spacing--mb-8'>1. Go to <a href="https://idlocker.nike.com/" className="eds-link">idlocker.nike.com</a></Text>
          <Text className='eds-spacing--mb-8'>2. Request access for the following group - App.CCH.Trade.FilingSpecialist</Text>
          <Text className='eds-spacing--mb-8'>3. Wait for approval</Text>
        </div>
        <Footer />
    </div>
  )
}
